import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { QrCodes } from "./components/Navbar/qrCodes";

function App() {
  return (
    <Router>
      {/* <NavBar /> */}
      <Routes>
        <Route exact path="/" element={<QrCodes />} />
        <Route exact path="/qr-codes" />
      </Routes>
    </Router>
  );
}

export default App;
